<template>
  <router-view />
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ReferralLayout',
  mounted() {
    document.querySelector('html').classList.add('has-background-white');
  }
};
</script>
